import { buildLaneKey, requireCanonicalSaleType } from './einvoice.contract'
import { createClientValidationError } from './einvoice.action-errors'

function firstDefined(...values) {
  return values.find((value) => value !== undefined && value !== null && value !== '')
}

function normalizeCanonicalNullableValue(value) {
  if (value === null || value === undefined) {
    return null
  }

  if (typeof value === 'string') {
    const normalized = value.trim()
    return normalized || null
  }

  const normalized = String(value).trim()
  return normalized || null
}

export function requireCanonicalSalesInvoiceId(salesInvoiceId, errorMessage) {
  const normalized = normalizeCanonicalNullableValue(salesInvoiceId)
  if (!normalized) {
    throw createClientValidationError(
      'EINVOICE_CANONICAL_CONTEXT_MISSING',
      errorMessage || 'Thiếu salesInvoiceId để định tuyến canonical endpoint',
    )
  }

  return normalized
}

export function requireCanonicalActionContext(payload = {}, actionLabel = 'thực hiện thao tác') {
  const source = payload && typeof payload === 'object' ? payload : {}
  const salesInvoiceId = requireCanonicalSalesInvoiceId(
    firstDefined(source.salesInvoiceId, null),
    `Thiếu salesInvoiceId để ${actionLabel}`,
  )
  const saleType = requireCanonicalSaleType(
    source.saleType,
    `Thiếu saleType hợp lệ để ${actionLabel}`,
  )

  return {
    salesInvoiceId,
    saleType,
    laneKey: buildLaneKey(salesInvoiceId, saleType),
  }
}
